// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD_8VaBoZmiLaVtY_IyN-yVwRB812kqZp0",
  authDomain: "homeo-96e9d.firebaseapp.com",
  projectId: "homeo-96e9d",
  storageBucket: "homeo-96e9d.firebasestorage.app",
  messagingSenderId: "841218290910",
  appId: "1:841218290910:web:479f0ab496d37d46207e4f"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { provider, auth };